
// import React from "react";
// import { Card, Box, Typography, Button, Modal, CircularProgress, Grid } from "@mui/material";
// import { DecorativeCorner } from "../../common/DecorativeCorner";
// import SendIcon from "@mui/icons-material/Send";
// import AccountCircleIcon from '@mui/icons-material/AccountCircle';
// import BlockIcon from '@mui/icons-material/Block';
// import axios from "axios";
// import { showError, showSuccess } from "./sweetAlert/sweetAlert";
// import { matrimoneyEndPoints } from "../../../services/apis";
// import { FontStyles } from "../../styles/FontStyles";
// const ViewDetaliesDashbord = (props) => {
//     const { profileData,profileId } = props
//     let userType = sessionStorage.getItem("userType")
//     let action = sessionStorage.getItem("action")
//     const profile = localStorage.getItem("profileData");
//     const storedProfileData = JSON.parse(profile)
// 	let token
// 	if(userType){
// 		token = sessionStorage.getItem("token");
// 	}else{
// 		 token = localStorage.getItem("token");
// 	}
//     // debugger
//     const isNameAvailable = !!profileData?.data?.["Profile Details"]?.["Full Name"];
//     const shortListProfile = async()=>{
//         try {
//             const response = await axios.post(
//               matrimoneyEndPoints.SHORT_LIST_PROFILE,
//               { "profileId": profileId },
//               {
//                 headers: {
//                   Authorization: `Bearer ${token}`,
//                   "Content-Type": "application/json",
//                 },
//               }
//             );

//             if (response.data.status) {
//               showSuccess(response.data?.message)

//             } else {
//               showError(response.data?.message)
//             }
//           } catch (error) {
//             console.error("GET_HEALTH_CONDITION_LIST API ERROR:", error);
//           }
//     }
//     const  blockListProfile = async()=>{
//         try {
//             const response = await axios.post(
//               matrimoneyEndPoints.BLOCK_LIST_PROFILE,
//               { "profileId": profileId },
//               {
//                 headers: {
//                   Authorization: `Bearer ${token}`,
//                   "Content-Type": "application/json",
//                 },
//               }
//             );

//             if (response.data.status) {
//               showSuccess(response.data?.message)

//             } else {
//               showError(response.data?.message)
//             }
//           } catch (error) {
//             console.error("GET_HEALTH_CONDITION_LIST API ERROR:", error);
//           }
//     }
//     const sendInterestProfile = async () => {
//         try {
//           const response = await axios.post(
//             matrimoneyEndPoints.SEND_INTEREST,
//             { "profileId": profileId },
//             {
//               headers: {
//                 Authorization: `Bearer ${token}`,
//                 "Content-Type": "application/json",
//               },
//             }
//           );

//           if (response.data.status) {
//             showSuccess(response.data?.message)

//           } else {
//             showError(response.data?.message)
//           }
//         } catch (error) {
//           console.error("GET_HEALTH_CONDITION_LIST API ERROR:", error);
//         }
//       }
//     return (
//         <>
//             <Box
//                 sx={{
//                     width: "100%",
//                     height: "auto",
//                     overflow: "hidden",
//                     display: "flex",
//                     flexDirection: { xs: "column", sm: "row" },
//                     justifyContent: "center",
//                     alignItems: "center",
//                     flexWrap: "wrap",
//                     width: { xs: "100%", sm: "100%" },
//                     marginTop: {
//                         xs: action === "viewProfile" ? 0 : "20%",
//                         sm: action === "viewProfile" ? 0 : "6.1%",
//                       },

//                     padding: "0px"
//                 }}
//             >
//                 <Card
//                     sx={{
//                         display: "flex",
//                         alignItems: "center",
//                         gap: 2,
//                         padding: { xs: "20px 20px", sm: "20px" },
//                         width: "100%",
//                         height: { xs: "auto", sm: "auto" },
//                         flexDirection: { xs: "column", sm: "row" },
//                         textAlign: { xs: "center", sm: "left" },
//                         position: "relative",
//                         boxShadow: "none",
//                         borderLeft: "none",
//                         borderRight: "none"
//                     }}
//                 >
//                     <DecorativeCorner sx={{
//                         top: { xs: -10, sm: -20 },
//                         left: { xs: -10, sm: -20 },
//                         width: { xs: "60px", sm: "100px" },
//                         height: { xs: "60px", sm: "100px" }
//                     }} />
//                     <DecorativeCorner sx={{
//                         bottom: { xs: -10, sm: -20 },
//                         right: { xs: -10, sm: -20 },
//                         width: { xs: "60px", sm: "100px" },
//                         height: { xs: "60px", sm: "100px" }
//                     }} />

//                     <Box
//                         component="img"
//                         src="/images/mandala.png"
//                         alt="Background"
//                         sx={{
//                             position: "absolute",
//                             top: "50%",
//                             left: "50%",
//                             transform: "translate(-50%, -50%)",
//                             width: { xs: "280px", sm: "250px", md: "250px", lg: "422px", xl: "500px" },
//                             opacity: 0.08,
//                             zIndex: 0,
//                         }}
//                     />

//                     <Box sx={{ zIndex: 1 }}>
//                         <Box
//                             sx={{
//                                 position: "relative",
//                                 width: { xs: "190px", sm: "150px", md: "180px" },
//                                 height: { xs: "190px", sm: "150px", md: "180px" },
//                                 display: "flex",
//                                 justifyContent: "center",
//                                 alignItems: "center",
//                                 marginLeft: { sm: "20%", md: "80%" },

//                             }}
//                         >
//                             <CircularProgress
//                                 variant="determinate"
//                                 value={100}
//                                 size={180}
//                                 thickness={2}
//                                 sx={{
//                                     position: "absolute",
//                                     color: "#F0E0D0",
//                                 }}
//                             />
//                             <CircularProgress
//                                 variant="determinate"
//                                 value={profileData?.data?.profileStrength}
//                                 size={180}
//                                 thickness={2}
//                                 sx={{
//                                     position: "absolute",
//                                     color: "#c1721f",
//                                 }}
//                             />
//                             <Box
//                                 component="img"
//                                 src={profileData?.data?.profilePicture || "/images/men.jpeg"} alt="Profile"
//                                 sx={{
//                                     width: "88%",
//                                     height: "88%",
//                                     borderRadius: "50%",
//                                     objectFit: "cover",
//                                     padding: "5px",
//                                     position: "absolute",
//                                 }}
//                             />
//                         </Box>
//                     </Box>
//                     <Grid container spacing={0} sx={{ marginLeft: { sm: "10%" } }} alignItems="center">
//                         <Grid item xs={12} sm={5}>
//                            <Typography sx={{ ...FontStyles.profilename }}>
//                                 {profileData?.data?.name || "annapurna marriages"}
//                             </Typography>
//                             <Box sx={{ display: "flex", gap: 2 }}>
//                                    <Typography sx={{ ...FontStyles.cardid }}>
//                                     {profileData?.data?.profileId || ""}
//                                 </Typography>
//                                 <Button
//                                     sx={{
//                                         backgroundColor: "#006400",
//                                         color: "white",
//                                         px: 2,
//                                         fontFamily: '"SF Pro Display", sans-serif',
//                                         fontWeight: 700,
//                                         fontSize: '16px',
//                                         width: { xs: "25px", sm: "25px" },
//                                         height: { xs: "25px", sm: "35px" },
//                                         lineHeight: '100%',
//                                         marginLeft: { xs: "110px", sm: "0px" },
//                                         justifyContent: { xs: "center" },
//                                         alignItems: { xs: "center" },
//                                         letterSpacing: '0%',
//                                         "&:hover": { backgroundColor: "#006400" },
//                                     }}

//                                 >
//                                     {profileData && profileData?.data ? profileData?.data?.plan : ""}

//                                 </Button>
//                             </Box>
//                         </Grid>

//                         <Grid item xs={12} sm={6} sx={{
//                             marginTop: { xs: "0px", sm: isNameAvailable ? "3px" : "3px" }
//                         }}>
//                             <Box
//                                 sx={{
//                                     display: "flex",
//                                     justifyContent: { xs: "center", },
//                                     alignItems: "center",
//                                     flexWrap: "wrap",
//                                     gap: 2,
//                                 }}
//                             >
//                                 {(!userType && storedProfileData?.id != profileId) && <Button onClick={shortListProfile}
//                                 startIcon={<AccountCircleIcon sx={{width:"30px",height:"30px"}} />}
//                                     sx={{
//                                         backgroundColor: "	#006400",
//                                         color: "white",
//                                         px: 2,
//                                         width: { xs: "100%", sm: "178px" },
//                                         height: "54px",
//                                         fontFamily: '"SF Pro Display", sans-serif',
//                                         padding: { sm: "10px" },
//                                         fontFamily: '"SF Pro Display", sans-serif',
//                                         fontWeight: 500,
//                                         fontSize: '24px',
//                                         lineHeight: '100%',
//                                         letterSpacing: '0%',
//                                         "&:hover": { backgroundColor: "green" },
//                                     }}
//                                 >
//                                     Shortlist
//                                 </Button>}

//                                 {!userType && storedProfileData?.id != profileId &&  <Button onClick={blockListProfile}
//                                 startIcon={< BlockIcon  sx={{width:"30px",height:"30px"}}/>}
//                                     sx={{
//                                         backgroundColor: "rgb(183, 14, 5)",
//                                         color: "white",
//                                         padding: { sm: "10px" },
//                                         width: { xs: "100%", sm: "178px" },
//                                         height: "54px",
//                                         fontFamily: '"SF Pro Display", sans-serif',
//                                         fontWeight: 500,
//                                         fontSize: '24px',
//                                         lineHeight: '100%',
//                                         letterSpacing: '0%',
//                                         letterSpacing: "0%",
//                                         "&:hover": { backgroundColor: "rgb(183, 14, 5)" },
//                                     }}
//                                 >
//                                     Blocklist
//                                 </Button>}

//                                 {!userType && storedProfileData?.id != profileId && <Button onClick={sendInterestProfile}
//                                                                  startIcon={<SendIcon  sx={{width:"30px",height:"30px"}} />}

//                                     sx={{
//                                         backgroundColor: "#C1721F",
//                                         color: "white",
//                                         px: 2,
//                                         width: { xs: "100%", sm: "188px" },
//                                         height: "54px",
//                                         fontFamily: '"SF Pro Display", sans-serif',
//                                         fontWeight: 500,
//                                         fontSize: '22px',
//                                         lineHeight: '100%',
//                                         letterSpacing: '0%',
//                                         padding: { sm: "10px" },
//                                         "&:hover": { backgroundColor: "#C1721F" },
//                                     }}
//                                 >
//                                     Send Interest
//                                 </Button>}
//                             </Box>
//                         </Grid>

//                     </Grid>
//                 </Card>
//             </Box>
//         </>
//     );
// };

// export default ViewDetaliesDashbord;


import React from "react";
import { Card, Box, Typography, Button, Modal, CircularProgress, Grid } from "@mui/material";
import { DecorativeCorner } from "../../common/DecorativeCorner";
import SendIcon from "@mui/icons-material/Send";
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import BlockIcon from '@mui/icons-material/Block';
import axios from "axios";
import { showError, showSuccess } from "./sweetAlert/sweetAlert";
import { matrimoneyEndPoints } from "../../../services/apis";
import { FontStyles } from "../../styles/FontStyles";
const ViewDetaliesDashbord = (props) => {
  const { profileData, profileId } = props
  let userType = sessionStorage.getItem("userType")
  let action = sessionStorage.getItem("action")
  const profile = localStorage.getItem("profileData");
  const storedProfileData = JSON.parse(profile)
  let token
  if (userType) {
    token = sessionStorage.getItem("token");
  } else {
    token = localStorage.getItem("token");
  }
  // debugger
  const isNameAvailable = !!profileData?.data?.["Profile Details"]?.["Full Name"];
  const shortListProfile = async () => {
    try {
      const response = await axios.post(
        matrimoneyEndPoints.SHORT_LIST_PROFILE,
        { "profileId": profileId },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      if (response.data.status) {
        showSuccess(response.data?.message)

      } else {
        showError(response.data?.message)
      }
    } catch (error) {
      console.error("GET_HEALTH_CONDITION_LIST API ERROR:", error);
    }
  }
  const blockListProfile = async () => {
    try {
      const response = await axios.post(
        matrimoneyEndPoints.BLOCK_LIST_PROFILE,
        { "profileId": profileId },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (response.data.status) {
        showSuccess(response.data?.message)

      } else {
        showError(response.data?.message)
      }
    } catch (error) {
      console.error("GET_HEALTH_CONDITION_LIST API ERROR:", error);
    }
  }
  const sendInterestProfile = async () => {
    try {
      const response = await axios.post(
        matrimoneyEndPoints.SEND_INTEREST,
        { "profileId": profileId },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (response.data.status) {
        showSuccess(response.data?.message)

      } else {
        showError(response.data?.message)
      }
    } catch (error) {
      console.error("GET_HEALTH_CONDITION_LIST API ERROR:", error);
    }
  }

  return (
    <>
      <Box
        sx={{
          width: "100%",
          height: "auto",
          overflow: "hidden",
          display: "flex",
          flexDirection: { xs: "column", sm: "row" },
          justifyContent: "center",
          alignItems: "center",
          flexWrap: "wrap",
          width: { xs: "100%", sm: "100%" },
          marginTop: {
            xs: action === "viewProfile" ? 0 : "20%",
            sm: action === "viewProfile" ? 0 : "6.1%",
          },

          padding: "0px"
        }}
      >
        <Card
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 2,
            padding: { xs: "20px 20px", sm: "20px" },
            width: "100%",
            height: { xs: "auto", sm: "auto" },
            flexDirection: { xs: "column", sm: "row" },
            textAlign: { xs: "center", sm: "left" },
            position: "relative",
            boxShadow: "none",
            borderLeft: "none",
            borderRight: "none"
          }}
        >
          <DecorativeCorner sx={{
            top: { xs: -10, sm: -20 },
            left: { xs: -10, sm: -20 },
            width: { xs: "60px", sm: "100px" },
            height: { xs: "60px", sm: "100px" }
          }} />
          <DecorativeCorner sx={{
            bottom: { xs: -10, sm: -20 },
            right: { xs: -10, sm: -20 },
            width: { xs: "60px", sm: "100px" },
            height: { xs: "60px", sm: "100px" }
          }} />

          <Box
            component="img"
            src="/images/mandala.png"
            alt="Background"
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: { xs: "280px", sm: "250px", md: "250px", lg: "422px", xl: "500px" },
              opacity: 0.08,
              zIndex: 0,
            }}
          />

          <Box sx={{ zIndex: 1 }}>
            <Box
              sx={{
                position: "relative",
                width: { xs: "190px", sm: "150px", md: "180px" },
                height: { xs: "190px", sm: "150px", md: "180px" },
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                marginLeft: { sm: "20%", md: "40%" },

              }}
            >
              <CircularProgress
                variant="determinate"
                value={100}
                size={180}
                thickness={2}
                sx={{
                  position: "absolute",
                  color: "#F0E0D0",
                }}
              />
              <CircularProgress
                variant="determinate"
                value={profileData?.data?.profileStrength}
                size={180}
                thickness={2}
                sx={{
                  position: "absolute",
                  color: "#c1721f",
                }}
              />
              <Box
                component="img"
                src={profileData?.data?.profilePicture || "/images/men.jpeg"} alt="Profile"
                sx={{
                  width: "88%",
                  height: "88%",
                  borderRadius: "50%",
                  objectFit: "cover",
                  padding: "5px",
                  position: "absolute",
                }}
              />
            </Box>
          </Box>
          <Grid container spacing={0} sx={{ marginLeft: { sm: "5%" } }} alignItems="center">
            <Grid item xs={12} sm={4}>
              <Typography sx={{ ...FontStyles.profilename }}>
                {profileData?.data?.name || "annapurna marriages"}
              </Typography>
              <Box sx={{ display: "flex", gap: 2 }}>
                <Typography sx={{ ...FontStyles.cardid }}>
                  {profileData?.data?.profileId || ""}
                </Typography>
                <Button
                  sx={{
                    ...FontStyles.cardplanbutton
                  }}

                >
                  {profileData && profileData?.data ? profileData?.data?.plan : ""}

                </Button>
              </Box>
            </Grid>

            <Grid item xs={12} sm={8} sx={{
              marginTop: { xs: "0px", sm: isNameAvailable ? "3px" : "3px" }
            }}>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: { xs: "center", },
                  alignItems: "center",
                  flexWrap: "wrap",
                  gap: 2,
                }}
              >

                {/* {
                  profileData?.data?.blockedStatus === false &&
                  profileData?.data?.shortListStatus === false &&
                  profileData?.shortListResponse?.status !== true &&
                  !userType &&
                  storedProfileData?.id !== profileId && (
                    <Button onClick={shortListProfile}
                      startIcon={<AccountCircleIcon sx={{ width: "30px", height: "30px" }} />}
                      sx={{
                        backgroundColor: "#006400",
                        color: "white",
                        px: 2,
                        width: { xs: "100%", sm: "178px" },
                        height: "54px",
                        fontFamily: '"SF Pro Display", sans-serif',
                        padding: { sm: "10px" },
                        fontWeight: 500,
                        fontSize: '24px',
                        lineHeight: '100%',
                        letterSpacing: '0%',
                        "&:hover": { backgroundColor: "green" },
                      }}
                    >
                      Shortlist
                    </Button>
                  )
                }
 */}
                {
                  profileData?.data?.blockedStatus === false &&
                  !userType &&
                  storedProfileData?.id !== profileId && (
                    profileData?.data?.shortListStatus === false &&
                      profileData?.shortListResponse?.status !== true ? (
                      <Button
                        onClick={shortListProfile}
                        startIcon={<AccountCircleIcon sx={{ width: "30px", height: "30px" }} />}
                        sx={{
                          backgroundColor: "#006400",
                          color: "white",
                          px: 2,
                          width: { xs: "100%", sm: "178px" },
                          height: "54px",
                          fontFamily: '"SF Pro Display", sans-serif',
                          padding: { sm: "10px" },
                          fontWeight: 500,
                          fontSize: '24px',
                          lineHeight: '100%',
                          letterSpacing: '0%',
                          "&:hover": { backgroundColor: "green" },
                        }}
                      >
                        Shortlist
                      </Button>
                    ) : (
                      <Button
                        startIcon={<AccountCircleIcon sx={{ width: "30px", height: "30px" }} />}
                        sx={{
                          backgroundColor: "#006400",
                          color: "white",
                          px: 2,
                          width: { xs: "100%", sm: "auto" },
                          height: "54px",
                          fontFamily: '"SF Pro Display", sans-serif',
                          padding: { sm: "10px" },
                          fontWeight: 500,
                          fontSize: '24px',
                          lineHeight: '100%',
                          letterSpacing: '0%',
                          "&:hover": { backgroundColor: "green" },
                        }}
                      >
                        Shortlisted At {profileData?.data?.shortListedAt}
                      </Button>
                    )
                  )
                }


                {!userType && storedProfileData?.id !== profileId && (
                  profileData?.data?.blockedStatus === true ? (
                    <Button
                      startIcon={<BlockIcon sx={{ width: "30px", height: "30px" }} />}
                      sx={{
                        backgroundColor: "rgb(183, 14, 5)",
                        color: "white",
                        padding: { sm: "10px" },
                        width: { xs: "100%", sm: "auto" },
                        height: "54px",
                        fontFamily: '"SF Pro Display", sans-serif',
                        fontWeight: 500,
                        fontSize: '24px',
                        lineHeight: '100%',
                        letterSpacing: '0%',
                        "&:hover": { backgroundColor: "rgb(183, 14, 5)" },
                      }}
                    >
                      Blocked At {profileData?.data?.blockedAt}
                    </Button>
                  ) : (
                    <Button onClick={blockListProfile}
                      startIcon={<BlockIcon sx={{ width: "30px", height: "30px" }} />}
                      sx={{
                        backgroundColor: "rgb(183, 14, 5)",
                        color: "white",
                        padding: { sm: "10px" },
                        width: { xs: "100%", sm: "178px" },
                        height: "54px",
                        fontFamily: '"SF Pro Display", sans-serif',
                        fontWeight: 500,
                        fontSize: '24px',
                        lineHeight: '100%',
                        letterSpacing: '0%',
                        "&:hover": { backgroundColor: "rgb(183, 14, 5)" },
                      }}
                    >
                      Blocklist
                    </Button>
                  )
                )}


                {profileData?.data?.blockedStatus === false &&
                  profileData?.blockListResponse?.status !== true &&
                  !userType &&
                  storedProfileData?.id !== profileId && (
                    profileData?.data?.sendInterestStatus === false ? (
                      <Button onClick={sendInterestProfile}
                        startIcon={<SendIcon sx={{ width: "30px", height: "30px" }} />}
                        sx={{
                          backgroundColor: "#C1721F",
                          color: "white",
                          px: 2,
                          width: { xs: "100%", sm: "188px" },
                          height: "54px",
                          fontFamily: '"SF Pro Display", sans-serif',
                          fontWeight: 500,
                          fontSize: '22px',
                          lineHeight: '100%',
                          letterSpacing: '0%',
                          padding: { sm: "10px" },
                          "&:hover": { backgroundColor: "#C1721F" },
                        }}
                      >
                        Send Interest
                      </Button>
                    ) : (
                      <Button
                        startIcon={<SendIcon sx={{ width: "30px", height: "30px" }} />}
                        sx={{
                          backgroundColor: "#C1721F",
                          color: "white",
                          px: 2,
                          width: { xs: "100%", sm: "auto" },
                          height: "54px",
                          fontFamily: '"SF Pro Display", sans-serif',
                          fontWeight: 500,
                          fontSize: '22px',
                          lineHeight: '100%',
                          letterSpacing: '0%',
                          padding: { sm: "10px" },
                          "&:hover": { backgroundColor: "#C1721F" },
                        }}
                      >
                        Sent Interest At {profileData?.data?.interestCreatedAt}
                      </Button>
                    )
                  )}

                {/* <>
                  {
                       profileData?.data?.blockedStatus === false &&
                    profileData?.data?.interestStatus === "accepted" && (
                      <Button
                        variant="contained"
                        sx={{
                          ...FontStyles.accept
                        }}
                        onClick={() => getAccept(profile.id)}>
                        Accept
                      </Button>
                    )
                  }

                  <Button
                    variant="contained"
                    sx={{
                      ...FontStyles.ignore
                    }}
                    onClick={() => getIGNORE(profile.id)}
                  >
                    Ignore
                  </Button>
                </> */}
              </Box>
            </Grid>

          </Grid>
        </Card>
      </Box>
    </>
  );
};

export default ViewDetaliesDashbord;
